const ContentsParser = {
  parse (str) {
    let parseResult = this.parseURL(str);
    parseResult = this.parseTitle(parseResult);
    parseResult = this.parseNextCard(parseResult);
    parseResult = this.parseDivider(parseResult);
    parseResult = this.parseImg(parseResult);
    parseResult = this.parseYoutube(parseResult);
    parseResult = this.parseStrong(parseResult);
    return "<p>" + parseResult + "</p>"
  },
  parseURL(str) {
    //const autoURLRegex = /https?:\/\/[^\s]+/g;
    const urlRegex = /\$url\(([^()]+),([^()]+)\)/g;
    return str.replace(urlRegex, (match, p1, p2) => {
      return `<a class="riclothes-product--url" href="${p2}" target="_blank">${p1}</a>`;
    });
  },
  parseTitle(str) {
    const titleRegex = /\$title\(([^()]+)\)(\r\n|\n|)/g
    return str.replace(titleRegex, (match, p1) => {
      return `</p> <p class="riclothes-product--title">${p1}</p> <p>`;
    })
  },
  parseNextCard(str) {
    const nextCardRegex = /\$next_card(\r\n|\n|)/g;
    return str.replace(nextCardRegex, "</p>$next_card<p>")
  },
  parseDivider(str) {
    const dividerRegex = /\$divider/g
    return str.replace(dividerRegex, `</p><div class="riclothes-product--dividers"></div><p>`);
  },
  parseYoutube(str) {
    const youtubeRegex = /\$youtube\(([^()\s]+)\)/g
    return str.replace(youtubeRegex, (match, p1) => {
      return `</p>
<div class="riclothes-product--video">
  <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/${p1}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
<p>`
    })
  },
  parseImg(str) {
    const imgRegex = /\$img\(([^()\s]+)\)/g
    return str.replace(imgRegex, (match, p1) => {
      return `</p><p><img class="riclothes-product--img" src=${p1}></p><p>`;
    });
  },
  parseStrong(str) {
    const strongRegex = /\$strong\(([^()]+)\)/g
    return str.replace(strongRegex, (match, p1) => {
      return `<strong>${p1}</strong>`
    });
  }
};

export default ContentsParser;